/** Keep the current surface and filters when a card opens as a global overlay. */
export function cardLocation(route, id) {
    return { path: route.path, query: { ...route.query, card: String(id) }, hash: route.hash || '' }
}

/** Updates are cross-company. A cold/new tab needs the destination's company as well. */
export function feedLocation(item, route) {
    const link = item?.link
    if (!link) return null
    const card = link.match(/^\/personal-assistant\/board\/card-(\d+)(?:[?#]|$)/)
    if (card) return cardLocation(route, card[1])
    if (/^https?:\/\//i.test(link)) return link
    if (!link.startsWith('/') || link.startsWith('//')) return null
    if (!item.company_id) return link
    const url = new URL(link, 'https://cortex.invalid')
    url.searchParams.set('company_id', String(item.company_id))
    return url.pathname + url.search + url.hash
}

/** A URL can choose an already authorised company; it cannot grant company access. */
export function linkedCompanyId(value, companies) {
    if (typeof value !== 'string' || !/^[1-9]\d*$/.test(value)) return null
    const id = Number(value)
    return Number.isSafeInteger(id) && companies.some(company => Number(company.id) === id) ? id : null
}
